module.exports = __webpack_public_path__ + "img/infinite-loop-logo.4e74e3c6.png";